import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from '@mui/icons-material/Download';
import PaymentsList from "../../features/managePayments/paymentsList";
import { useLazyGetPaymentQuery } from "../../services/payout";
import { showError } from "../../constants/toasts";
import { PaymentBookingItem } from "../../types/Payments";

const ManagePayments = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [getPayment] = useLazyGetPaymentQuery()
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState<PaymentBookingItem[]>([]);
  const [totalCommission, setTotalCommission] = useState<number>(0);


  const fetchPayment = async () => {
    try {
      const response = await getPayment({
        from: page,
        size: pageSize,
        search: searchTerm,
      }).unwrap();

      if (response?.statusCode === 200) {
        setRows(response.data.allBookings.data || []);
        setTotalCount(response.data.allBookings.total || 0);
        setTotalCommission(response.data.totalCommission || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch");
    }
  };

  useEffect(() => {
    fetchPayment()
  }, [searchTerm, page, pageSize])

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Payments</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Payments
        </p>
      </div>

      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/dashboard/unregistered-users")}>
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>${totalCommission?.toFixed(2)}</h2>
          <p>Total Commision Recieved</p>
        </div>
      </div>
      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_grey"><DownloadIcon /> Export</Button>
          </div>
        </div>
        <PaymentsList
          rows={rows}
          count={totalCount}
          page={page}
          onPageChange={(e: any, newPage: number) => setPage(newPage)}
        />
      </div>
    </MainContainer>
  );
};

export default ManagePayments;
